import { AxiosInstance } from "axios";
import { unstrapiMany, unstrapiOne } from "../../helpers/strapi";
import {
  UserDocument,
  UserDocumentCreate
} from "../../types/user-document-types";
import { FindManyParams } from "../types";
import { BaseApiModule } from "./base.module";

const MODULE_PATH = "api/user-documents";

export class UserDocumentApiModule extends BaseApiModule {
  constructor(client: AxiosInstance) {
    super(client, MODULE_PATH);
  }

  async create(data: UserDocumentCreate) {
    const response = await this.client.post(this.buildPath(), { data });
    const userDocument = unstrapiOne<UserDocument>(
      response.data,
      "userDocument"
    );
    return userDocument;
  }

  async findMany(params: FindManyParams = {}) {
    const response = await this.client.get(this.buildPath(), {
      params
    });
    const userDocuments = unstrapiMany<UserDocument>(
      response.data,
      "userDocument",
      true
    );
    return userDocuments;
  }
}
